import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-no-stock',
  templateUrl: './custom-no-stock.component.html'
})
export class CustomNoStockComponent {
  @Input()
  search = ''
}
